import { Component, OnInit, inject } from '@angular/core';
import { LocaleService } from '@next/core-lib/i18n';
import { SiteActions, SiteSelectors, SiteState } from '@next/core-lib/site';
import { Store, select } from '@ngrx/store';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  standalone: false,
})
export class DashboardComponent implements OnInit {
  private readonly store = inject<Store<SiteState>>(Store);
  private readonly localeService = inject(LocaleService);

  pageTitle$ = this.store.pipe(select(SiteSelectors.selectPageTitle));

  ngOnInit() {
    this.store.dispatch(
      SiteActions.updatePageTitle({
        pageTitle: this.localeService.translate('dashboard.page-title'),
      }),
    );
  }
}
